import { Component, HostBinding, Input, OnInit, inject, output } from '@angular/core';

import { OVERLAY_DATA } from '@app-core/services/overlay';
import { IconComponent } from '@app-shared/components/icon/icon.component';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

import { NotificationItem } from './notification.interface';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  imports: [IconComponent],
})
export class NotificationComponent implements NotificationItem, OnInit {
  notification = inject<NotificationItem>(OVERLAY_DATA);

  @Input({ required: true }) duration: number = 0;
  @Input({ required: true }) value: { message: string; title?: string };
  @Input({ required: true }) id: string = '';
  @Input({ required: true }) type: 'warning' | 'success' = 'warning';

  readonly closed = output<string>();

  @HostBinding('class') get classes() {
    return {
      warning: this.type === 'warning',
      success: this.type === 'success',
    };
  }

  ngOnInit(): void {
    this.duration > 0 &&
      of([])
        .pipe(delay(this.duration))
        .subscribe(() => this.close());
  }

  close(): void {
    this.closed.emit(this.id);
  }
}
